import axios from "axios";

export interface ContactFormData {
  email: string;
  msisdn: string;
  message: string;
}

export const sendContactForm = async (data: ContactFormData): Promise<void> => {
  const response = await axios.post("/mail/send-form", data, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, */*",
    },
  });

  if (response.status !== 200) {
    throw new Error("Failed to send contact form");
  }

  return response.data;
};
